export const requestNew = ({ confirmation = true, ...opts }) => ({
    ...opts,
    type: 'new',
    resourceType: opts.resourceType,
    changeLabel: `Create ${opts.resourceType.initialName}`,
    historyOptions: {
        confirmation: (confirmation) ? {
            message: `Are you sure you want to delete "${opts.resourceType.initialName}"?`,
            onUndo: true,
        } : undefined,
    },
});
export const requestUpdate = (opts) => ({
    type: 'update',
    ...opts,
});
export const requestDelete = ({ confirmation = true, ...opts }) => ({
    type: 'delete',
    changeLabel: `Delete ${opts.resource.name}`,
    historyOptions: {
        confirmation: (confirmation) ? {
            message: `Are you sure you want to delete "${opts.resource.name}"?`,
            onCommit: true,
            onRedo: true,
        } : undefined,
    },
    ...opts,
});
;
export const requestComposite = (opts) => {
    return {
        type: 'composite',
        ...opts,
        requests: opts.requests.reduce((list, request) => [...list, {
                ...request,
                changeLabel: opts.changeLabel,
                historyOptions: opts.historyOptions,
                origin: opts.origin,
            }], [])
    };
};
//# sourceMappingURL=requests.js.map